import React from 'react'
// components
import ObjectUpdateContainer from 'containers/ObjectsAndProperties/Edit'

const ObjectEditPage: React.FC = () => <ObjectUpdateContainer />

export default ObjectEditPage
